import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgCompare from '../../svg/compare.svg'
import { IconProps } from '../icon-props'

const CompareIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgCompare
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-compare', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default CompareIcon
